import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<rect width=\"40\" height=\"40\" fill=\"url(#i65442389__a)\" rx=\"8.125\"></rect><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M20.24 15.42v-4.326h15.385v4.327h-5.529v13.461H25.77V15.421H20.24Zm-15.865 0v-4.326H19.76v4.327h-5.53v13.461H9.905V15.421H4.375Z\" clip-rule=\"evenodd\"></path><defs><linearGradient id=\"i65442389__a\" x1=\"3.364\" x2=\"19.988\" y1=\"2.511\" y2=\"19.987\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#00FFC3\"></stop><stop offset=\"1\" stop-color=\"#00AF86\"></stop></linearGradient></defs>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }